export default __webpack_public_path__ + "static/media/step3.120c2468.png";